export default __webpack_public_path__ + "static/media/tee-thumb.6e23be22.png";